import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ActionsRow from './ActionsRow'
import _ from 'lodash';

class AttachmentTable extends Component{
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    renderModelRow(){
        return this.props.attachments[this.props.type].map((attachment)=>{
            let urlThumb = attachment.thumb ? "/" + attachment.thumb : null;
            return (<tr key={attachment.id}>
                <td>
                    <img style={{width:"48px", height:"48px"}} src={urlThumb} />{' '}
                    {attachment.name}
                </td>
                <td>
                    <ActionsRow
                        attachment={attachment}
                        actionDelete={this.props.actionDelete.bind(this)}
                        showAttachment={this.props.showAttachment.bind(this)}
                        downloadAttachment={this.props.downloadAttachment.bind(this)}
                    />
                </td>
            </tr>)
        })
    }
    renderBoxRow(){
        return this.props.attachments[this.props.type].map((attachment)=>{
            let urlThumb = attachment.thumb ? "/" + attachment.thumb : null;
            return (<tr key={attachment.id}>
                <td>
                    {urlThumb ?
                        <img style={{width:"48px", height:"48px"}} src={urlThumb} />
                    :
                        <i className="fa fa-file-o fa-2x text-muted" /> }{' '}
                    {!attachment.status &&  attachment.user_id !== this.props.userId ? <b>{attachment.name}</b> : attachment.name }
                </td>
                <td>
                    {attachment.user_id === this.props.userId ?
                        <span className="text-muted small"><i className="fa fa-user-circle-o" /> Subido por mi</span>
                        :
                        <span className="text-success small"><i className="fa fa-user-circle-o" /> {!this.props.isAdmin ? "Subido por el laboratorio" : "Subido por la clínica" }</span>
                    }
                </td>
                <td>
                    <ActionsRow
                        attachment={attachment}
                        actionDelete={this.props.actionDelete.bind(this)}
                        showAttachment={this.props.showAttachment.bind(this)}
                        downloadAttachment={this.props.downloadAttachment.bind(this)}
                    />
                </td>
            </tr>)
        })
    }
    render(){
        if(!this.props.attachments[this.props.type] || this.props.attachments[this.props.type].length === 0){
            return <span>&nbsp;</span>
        }else{
            if(this.props.type === "boxes"){
                return(
                    <div>
                        <table className="table table-hover">
                            <thead>
                            <tr>
                                <th>{this.props.title}</th>
                                <th>&nbsp;</th>
                                <th style={{width: "1%"}}>&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.renderBoxRow()}
                            </tbody>
                        </table>
                        <hr />
                    </div>
                )
            }else{
                return(
                    <div>
                        <table className="table table-hover">
                            <thead>
                            <tr>
                                <th>{this.props.title}</th>
                                <th style={{width: "1%"}}>&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.renderModelRow()}
                            </tbody>
                        </table>
                        <hr />
                    </div>
                )
            }
        }
    }
}
export default AttachmentTable;


// WEBPACK FOOTER //
// ./resources/assets/js/components/attachments/AttachmentTable.jsx